var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"cr-emoji-flag",class:( _obj = {}, _obj[("cr-emoji-flag-" + _vm.sizeComputed)] = _vm.sizeComputed, _obj ),style:({
    '--cr-emoji-flag-size': _vm.size,
  }),attrs:{"title":_vm.name,"role":"img","aria-label":_vm.name},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.emojiFlag(_vm.name)))])}
var staticRenderFns = []

export { render, staticRenderFns }